'use client';

import { QueryKeys } from '@/constants/query-keys';
import { theaterApiService } from '@/services/(frontend)/theaters/theater-api.service';
import { Theater } from '@cinemark/content-api-client';
import { useQuery } from '@tanstack/react-query';

export const useTheaterByTheaterId = (theaterId: number): ReturnType<typeof useQuery<Theater>> => {
  return useQuery<Theater>({
    enabled: theaterId > 0,
    queryFn: async () => {
      const response = await theaterApiService.getTheaterByTheaterId(theaterId);

      if (!response) {
        throw new Error('Theater not found');
      }

      return response;
    },
    queryKey: QueryKeys.global.theaterById(theaterId),
  });
};
